import {h, Fragment, Component} from "preact";
import {route} from "preact-router";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/sports.jsx";
import * as T from "../mobile-templates/tournament.jsx";
import * as I from "../utils/icons.jsx";
import User from "../../../services/user";
import {CashoutPage as Cashout} from "./cashout";

import FullSite from "./full-site";

import { 
	LivePage as AwrabetLivePage,
	Tournament as AwrabetTournament,
	Category as AwrabetCategory 
} from "../../awrabet/mobile-pages/live.jsx";
import { LiveEventsBadge } from "./home.jsx";
import PrematchFeedService from "../../../services/prematch-feed";


export default function Live(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><LivePage {...props} /></FullSite>
}

export class LivePage extends AwrabetLivePage {
	FAVOURITES_TAG = "/favourites";
	state = {
		sport: null,
		showmybets: false,
		oldsport: null
	};
	componentWillMount() {
		this.useBestSport();
		LFeed.onUpdate(this.updateFn = () => {
			this.useBestSport();
		})
	}
	componentDidUnmount() {
		LFeed.stopUpdate(this.updateFn)
	}
	useBestSport() {
		if (this.state.showmybets || LFeed.menu == null || Object.keys(LFeed.menu).length == 0)
			return;
		if (this.state.sport === null || (this.state.sport != this.FAVOURITES_TAG && !LFeed.menu[this.state.sport])) {
			let firstAttempt = '/sport/'+this.props.sportId;
			const sportId = !!LFeed.menu[firstAttempt]
				? firstAttempt
				: Object.values(LFeed.menu).sort((a, b) =>a.order - b.order)[0].id;
			this.setState({sport: sportId})
		} else {
			this.setState({})
		}
	}
	setSport(sport) {
		this.setState({sport: sport.id, showmybets: false})
		this.setSportRoute(sport.id.split('/').slice(-1)[0])
	}
	setSportRoute(sportId) {
		route('/live/'+sportId)
	}
	setFavourites() {
		this.setState({sport: this.FAVOURITES_TAG, showmybets: false})
	}
	setMyBets() {
		this.setState({oldsport: this.state.sport, sport: null, showmybets: true})
	}
	getCurrentSport() {
		if (this.FAVOURITES_TAG == this.state.sport) {
			return {name: "Favourites", id: this.FAVOURITES_TAG, count: '???'};
		}
		return LFeed.menu && LFeed.menu[this.state.sport];
	}
	getCategories() {
		if (this.FAVOURITES_TAG == this.state.sport) {
			return [];
		}
		// Prima ordinavamo per nome .sort((a, b) => a.name.localeCompare(b.name))
		return Object.values(this.getCurrentSport().sub)
			.sort((a, b) => a.name.localeCompare(b.name))
			.sort((a, b) => (a.category.order ?? Infinity) - (b.category.order ?? Infinity))
			.sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity))
			.sort((a, b) => b.elite - a.elite);
	}
	render() {
		const menu = LFeed.menu;
		return <Fragment>
			<P.SportsHolder>
				{User.isLogged() && <P.SportLikeButton
					onClick={e => this.setMyBets()}
					active={this.state.showmybets}>
					<P.SportIconBox><I.UserIcon class="h-full text-amber-500" /></P.SportIconBox>
					<P.SportName>My Bets</P.SportName>
				</P.SportLikeButton>}
				<P.SportLikeButton
					onClick={e => this.setFavourites()}
					active={this.FAVOURITES_TAG == this.state.sport}>
					<P.SportIconBox><I.FavouritesIcon class="h-full text-amber-500" /></P.SportIconBox>
					<P.SportName>Favourites</P.SportName>
				</P.SportLikeButton>
				<P.SportLikeButton onClick={e => route('/prematch')}>
					<P.SportIconBox>
						<I.Stopwatch class="h-full" />
					</P.SportIconBox>
					<P.SportName>Prematch</P.SportName>
				</P.SportLikeButton>
				{menu && Object.values(menu).sort((a, b) => a.order - b.order).map(sport => {
					return <P.SportButton
							   sport={sport}
							   active={sport.id == this.state.sport}
							   onClick={e => this.setSport(sport)}
							/>
				})}
			</P.SportsHolder>
			{!!this.state.showmybets && <Cashout onCloseCallback={() => this.setState({sport: this.state.oldsport, oldsport: null, showmybets: false})} />}
			{this.getCurrentSport() && <P.SportStrip sport={this.getCurrentSport()} />}
			{this.getCurrentSport() && <P.PageContainer key={this.state.sport}>
				{this.getCategories().map(tournament =>
					<Tournament key={tournament.id} tournament={tournament} />
				)}
			</P.PageContainer>}
		</Fragment>;
	}
}

export class Tournament extends AwrabetTournament {
	bestMarketCriteria(eventsLength, validStuff) {
		if (eventsLength == 1)
			return validStuff[0];
		if (validStuff[0] && Object.keys(validStuff[0].sub).length == 3)
			return validStuff[0];
		return validStuff[1] || validStuff[0];
	}
	outcomesList(events) {
		if (events.length == 0)
			return [];
		const validStuff = events.flatMap(event => Object.values(event.sub).filter(market => Object.keys(market.sub).length <= 3))
			.sort((a, b) => a.order - b.order);
		// Non e' magia nera, se l'evento e' uno sta bene il primo mercato.
		// Se ce ne sono diversi questo controllo mi assicura (empiricamente) che non scelgo un mercato che stia bene solo ad un evento a caso.
		const bestMarket = this.bestMarketCriteria(events.length, validStuff);
		if (!bestMarket)
			return [];
		const outcomesListFromMarket = Object.values(bestMarket.sub).map(outcome => ({
			id: outcome.id.split('/').slice(-2).join('.'),
			name: outcome.name
		}))
		return outcomesListFromMarket;
	}
	getOddFromEvent(event, outcomeRule) {
		const [mId, oId] = outcomeRule.id.split('.');
		const eventId = event.id.split('/').slice(-1)[0];
		return event.sub && event.sub['/market/'+eventId+'/'+mId] && event.sub['/market/'+eventId+'/'+mId].sub['/odd/'+eventId+'/'+mId+'/'+oId];
	}

	render({tournament}) {
		const oddsRule = this.outcomesList(Object.values(tournament.sub));

		return <Fragment>
			<T.TournamentDatesHeader>
				<T.TournamentDate>{tournament.name}</T.TournamentDate>
				{oddsRule.map(outcome => <T.OutcomeNameHeader>{outcome.name}</T.OutcomeNameHeader>)}
			</T.TournamentDatesHeader>
			{Object.values(tournament.sub).sort((a, b) => a.date - b.date).map(event => <T.MatchRow key={event.id}>
				<T.MatchInfo onClick={() => {route('/live'+event.id)}}>
					<T.Teams>
						<T.TeamWithScore>
							<T.HomeTeamName>{event.home}</T.HomeTeamName>
							<T.ScoreElement>{event.current.result[0]}</T.ScoreElement>
						</T.TeamWithScore>
						<T.TeamWithScore>
							<T.AwayTeamName>{event.away}</T.AwayTeamName>
							<T.ScoreElement>{event.current.result[1]}</T.ScoreElement>
						</T.TeamWithScore>
					</T.Teams>
					<T.MatchTime>{event.status.phase}{event.status.timer ? ' - ' + event.status.timer + "'" : ''}</T.MatchTime>
				</T.MatchInfo>
				{oddsRule.map(outcomeRule => <EasyOutcome outcome={this.getOddFromEvent(event, outcomeRule)} />)}
				<T.StarCell>Fv</T.StarCell>
			</T.MatchRow>)}
		</Fragment>
	}
}

function EasyOutcome({outcome}) {
	return <T.OddButtonCell>
		<T.OddButton
			value={outcome && outcome.value}
			active={true}
			selected={outcome && Ticket.hasLiveOdds(outcome.id)}
			onClick={() => Ticket.toggleLiveOdds(outcome.id)}
			/>
	</T.OddButtonCell>
}

export class Category extends AwrabetCategory {
	state = {
		open: false,
		wasOpen: false,
		checked: []
	};
	componentWillMount() {
		this.setState({
			open: this.props.open,
			wasOpen: this.props.open,
			checked: Object.values(this.props.category.sub).map(() => false) // Proseguire dalle checkbox
		})
	}
	getTournamentLink(tournament) {
		return "/prematch/"+tournament.id.split('/').slice(2).join('/')
	}
	render({category}) {
		return <P.CategorySelectionHolder>
			<P.CategorySelectionButton
				category={category}
				onClick={() => this.setState({open: !this.state.open, wasOpen: true})}
				onChecked={console.log}
				open={this.state.open}
			/>
			{this.state.wasOpen && <P.TournamentSelectionHolder open={this.state.open}>
				{Object.values(category.sub).sort((a, b) => a.order - b.order).map(tournament => {
					return <P.TournamentSelectionButton
							   tournament={tournament}
							   onClick={e => route(this.getTournamentLink(tournament))}
							/>
				})}
			</P.TournamentSelectionHolder>}
		</P.CategorySelectionHolder>
	}
}